<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>
        <div>
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group">
                                <input v-model="filter.search" type="text" class="form-control" placeholder="Search...">
                            </div>
                        </div>
                        <div class="col-md-4" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="col-md-4 float-right">
                        <button @click="openCreateModal" class="btn btn-primary btn-block">
                            Create
                        </button>
                    </div>
                </div>
            </div>
            <b-card no-body class="col-md-12 p-1">
                <!-- <div class="row">
                    <div class="col-md-2 ml-auto">
                        <div class="form-group">
                            <select v-model="perPage" class="form-control">
                                <option :value="5">5</option>
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="40">40</option>
                            </select>
                        </div>
                    </div>
                </div> -->
                <div class="row p-2">
                    <div class="col-md-12">
                        <div class="table-responsive-sm" style="overflow-x: auto">
                            <table class="table b-table table-fixed">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Nama</th>
                                        <th>Area</th>
                                        <th>Created At</th>
                                        <th>Created By</th>
                                        <th>Updated At</th>
                                        <th>Updated By</th>
                                        <th />
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="isLoading">
                                        <td colspan="10" class="text-center">
                                            <b-spinner label="Loading..." variant="primary" />
                                        </td>
                                    </tr>
                                    <template v-if="!isLoading">
                                        <tr v-for="(item, key) in result" :key="item.id">
                                            <td>{{ key + 1 }}</td>
                                            <td>{{ item.area_name }}</td>
                                            <td v-html="formatWilayah(item)"></td>
                                            <td>{{ item.created_at }}</td>
                                            <td>{{ item.created_by }}</td>
                                            <td>{{ item.updated_at }}</td>
                                            <td>{{ item.updated_by }}</td>
                                            <td class="text-right">
                                                <div class="btn-group" role="group" aria-label="Basic example">
                                                    <button class="btn btn-info btn-sm" style="margin-left: 2px;" data-toggle="tooltip" data-placement="top" title="Edit" @click="editItem(item)">
                                                        <feather-icon icon="EditIcon" />
                                                    </button>
                                                    <button class="btn btn-danger btn-sm" style="margin-left: 2px;" data-toggle="tooltip" data-placement="top" title="Delete" @click="deleteItem(item.id)">
                                                        <feather-icon icon="Trash2Icon" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr v-if="!isLoading && result.length === 0">
                                        <td colspan="7" class="text-center">
                                            Data is empty.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="row mt-1">
                                <div class="col-6 pl-2">
                                    <small>Showing {{ result.length ? 1 : 0 }} to {{ result.length }} from {{ result.length }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>

            <!-- Add/Edit Modal -->
            <b-modal id="form-modal" size="lg" :title="editId != null ? 'Edit Cabang - ' + formPayload.area_name : 'Add Cabang'" :no-close-on-backdrop="true">
                <div class="form-group">
                    <label for="v-nama">Nama Area <span class="text-danger">*</span></label>
                    <b-form-group>
                        <b-form-input id="v-nama" v-model="formPayload.area_name" type="text" placeholder="Nama" class="custom__input" />
                    </b-form-group>
                </div>
                <div class="form-group">
                    <label>Provinsi</label>
                    <v-select
                        v-model="formPayload.provinces"
                        :options="provinceOptions"
                        label="nama_provinsi"
                        :reduce="p => p.id"
                        placeholder="Pilih Provinsi"
                        multiple
                        :close-on-select="false"
                    />
                </div>
                <div class="form-group">
                    <label>Kota/Kabupaten</label>
                    <v-select
                        v-model="formPayload.cities"
                        :options="groupedCityOptions"
                        label="label"
                        :reduce="option => option.value"
                        :selectable="option => !option.isHeader"
                        :disabled="!formPayload.provinces.length"
                        placeholder="Pilih Kota/Kabupaten"
                        multiple
                        :close-on-select="false"
                    >
                        <template #option="{ label, isHeader }">
                            <div
                                v-if="isHeader"
                                style="font-weight: 600; color: #999; pointer-events: none; cursor: default;"
                            >
                                {{ label }}
                            </div>
                            <div v-else style="padding-left: 16px;">
                                {{ label }}
                            </div>
                        </template>
                    </v-select>
                </div>
                <hr>
                <template #modal-footer>
                    <div v-if="isLoading">
                        <b-spinner class="mb-2" variant="primary" />
                    </div>
                    <b-button v-if="editId == null" variant="success" :disabled="isLoading" @click="createItem()">
                        Save Item
                    </b-button>
                    <b-button v-else variant="success" :disabled="isLoading" @click="updateItem()">
                        Save Item
                    </b-button>
                </template>
            </b-modal>
            <!-- Add/Edit Modal -->
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {
        BCard,
        BSpinner,
        BButton,
        BFormGroup,
        BModal,
        BFormInput,
    } from 'bootstrap-vue'
    import { checkPermission, successNotification, errorNotification } from '@/auth/utils'
    import Vue from 'vue'
    import VuejsDialog from 'vuejs-dialog'
    import vSelect from 'vue-select'

    import 'vuejs-dialog/dist/vuejs-dialog.min.css'

    Vue.use(VuejsDialog)

    export default {
        components: {
            BCard,
            BSpinner,
            BButton,
            BFormGroup,
            BModal,
            BFormInput,
            vSelect,
        },
        title() {
            return 'Master Data - Area'
        },
        watch: {
            filter: {
                handler: _.debounce(function () {
                    this.getData(1)
                }, 300),
                deep: true,
            },
            'formPayload.provinces'(newVal, oldVal) {
                if (this.isEditing) return

                const removedProvinces = oldVal.filter(id => !newVal.includes(id))

                if (removedProvinces.length) {
                    // Remove cities that belong to removed provinces
                    this.formPayload.cities = this.formPayload.cities.filter(
                    cityId => {
                        const city = this.cityOptions.find(c => c.id === cityId)
                        // keep city if its province is still selected
                        return city && !removedProvinces.includes(city.provinsi_id)
                    }
                    )
                }

                if (newVal.length) {
                    this.getCities()
                }
            },
            perPage() {
                this.getData(1)
            },
        },
        setup() {
            return {
                checkPermission,
                successNotification,
                errorNotification,
            }
        },
        computed: {
            groupedCityOptions() {
                const result = []

                this.formPayload.provinces.forEach(provinceId => {
                    const province = this.provinceOptions.find(
                        p => p.id === provinceId,
                    )

                    if (!province) return

                    // Province header
                    result.push({
                        label: province.nama_provinsi,
                        value: null,
                        isHeader: true,
                    })

                    // Cities under it
                    this.cityOptions.filter(c => c.provinsi_id === province.id).forEach(city => {
                        result.push({
                            label: city.nama_kabkot,
                            value: city.id,
                            isHeader: false,
                        })
                    })
                })
                return result
            },
        },
        data() {
            return {
                currentPage: 1,
                result: [],
                isLoading: false,
                provinceOptions: [],
                cityOptions: [],
                cityLoading: false,
                editId: null,
                isEditing: false,
                formPayload: {
                    area_name: '',
                    provinces: [],
                    cities: [],
                },
                filter: {
                    search: '',
                },
                perPage: 10,
                userData: JSON.parse(localStorage.getItem('userData')),
            }
        },
        mounted() {
            this.getData()
            this.getProvinces()
        },
        methods: {
            resetForm() {
                this.editId = null
                this.formPayload = {
                    area_name: '',
                    provinces: [],
                    cities: [],
                }
            },
            openCreateModal() {
                this.editId = null
                this.resetForm()
                this.$bvModal.show('form-modal')
            },
            async editItem(item) {
                this.editId = item.id
                this.isEditing = true

                this.formPayload = {
                    area_name: item.area_name || '',
                    provinces: (item.provinces || []).map(p => p.id),
                    cities: (item.cities || []).map(c => c.id),
                }

                await this.getCities()
                this.isEditing = false

                this.$bvModal.show('form-modal')
            },
            formatWilayah(item) {
                const provinces = item.provinces || []
                const cities = item.cities || []

                if (!provinces.length) {
                    return '<strong>Seluruh Provinsi & Kota/Kabupaten</strong>'
                }

                return provinces.map(province => {
                    const provinceCities = cities
                        .filter(city => city.provinsi_id === province.id)
                        .map(city => city.nama_kabkot)

                return `<strong>${province.nama_provinsi}</strong>: ${
                    provinceCities.length ? provinceCities.join(', ') : 'Seluruh Kota/Kabupaten'
                }`
                }).join('<br>')
            },
            buildPayload() {
                return {
                    area_name: this.formPayload.area_name,
                    provinces: this.formPayload.provinces.map(provinceId => ({
                        id: provinceId,
                        cities: this.cityOptions
                            .filter(city =>
                                city.provinsi_id === provinceId &&
                                this.formPayload.cities.includes(city.id)
                            )
                            .map(city => ({
                                id: city.id,
                            })),
                    })),
                }
            },
            async getProvinces() {
                try {
                    const res = await this.$http.post('/regions/provinces')
                    this.provinceOptions = res.data.data || []
                } catch (err) {
                    console.log('error provinsi: ', err)
                }
            },
            searchCity: _.debounce(function (search) {
                this.getCities(search)
            }, 400),
            async getCities(search = '') {
                if (!this.formPayload.provinces.length) return

                this.cityLoading = true

                try {
                    const res = await this.$http.post('/regions/cities', {
                        province_id: this.formPayload.provinces,
                        search: search,
                    })

                    const newCities = res.data.data || []
                    const existingIds = this.cityOptions.map(c => c.id)
                    this.cityOptions = [
                        ...this.cityOptions,
                        ...newCities.filter(c => !existingIds.includes(c.id)),
                    ]
                } catch (err) {
                    console.log(err)
                } finally {
                    this.cityLoading = false
                }
            },
            getData(page = 1) {
                this.isLoading = true
                this.currentPage = page

                this.$http.post('/super-admin/master/regions/area', {
                    search: this.filter.search,
                }).then(response => {
                    this.result = response.data.data
                    this.isLoading = false
                }).catch(() => {
                    this.isLoading = false
                })
            },
            createItem() {
                this.isLoading = true
                const payload = {
                    ...this.buildPayload(),
                    user_id: this.userData.id,
                }
                this.$http.post('/super-admin/master/regions/save-area', payload)
                .then(response => {
                    this.$bvModal.hide('form-modal')
                    this.getData()
                    successNotification('Area created successfully!')
                    this.resetForm()
                    this.isLoading = false
                })
                .catch(error => {
                    if (error.response && error.response.data.errors) {
                        this.validations = error.response.data.errors
                    } else {
                        // errorNotification(this, 'Oops!', error.response.data.meta.messages)
                    }
                    this.isLoading = false
                })
            },
            updateItem() {
                if (!this.editId) return
                this.isLoading = true
                const payload = {
                    ...this.buildPayload(),
                    user_id: this.userData.id,
                }
                this.$http.patch(`/super-admin/master/regions/update-area/${this.editId}`, payload)
                .then(response => {
                    this.$bvModal.hide('form-modal')
                    this.getData()
                    successNotification('Area updated successfully!')
                    this.resetForm()
                    this.editId = null
                    this.isLoading = false
                })
                .catch(error => {
                    if (error.response && error.response.data.errors) {
                        this.validations = error.response.data.errors
                    } else {
                        // errorNotification('Failed to update COA')
                    }
                    this.isLoading = false
                })
            },
            deleteItem(id) {
                this.$swal({
                    title: 'Are you sure?',
                    text: 'Are you sure to delete this item?',
                    icon: 'warning',
                    showCancelButton: true,
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1',
                    },
                    buttonsStyling: false,
                }).then(result => {
                    if (result.value) {
                        this.$http.delete(`super-admin/master/regions/delete-area/${id}`)
                        .then(response => {
                            this.getData()
                            this.$swal({
                                icon: 'success',
                                title: 'Success!',
                                text: 'Item successfully deleted',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                },
                            })
                        })
                        .catch(error => {
                            if (error.response.data.meta.messages.length > 0) {
                                errorNotification(this, 'Oops!', error.response.data.meta.messages)
                            }
                        })
                    }
                })
            },
        },
    }
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    .status-pill {
        display: inline-block;
        padding: 0.25rem 0.75rem;
        border-radius: 999px;
        color: white;
        font-weight: 500;
        text-transform: capitalize;
        font-size: 0.875rem;
    }

    .status-pill.canceled {
        background-color: #dc3545; // red
    }

    .status-pill.expired {
        background-color: #6c757d; // gray
    }

    .status-pill.success {
        background-color: #28a745; // green
    }

    .status-pill.pending {
        background-color: #ffc107; // yellow
        color: #212529;
    }
</style>
